import React, { Component } from 'react'
import { CommonSuccessMessages, CommonValidationMessages } from '../../../utils/Messages';
import ItemMasterServices from '../../../services/axioServices/apiServices/ItemMasterServices';
import CommonServices from '../../../services/axioServices/apiServices/CommonServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import RawMaterialTestEntryInputs from './RawMaterialTestEntryInputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Navigate } from 'react-router-dom';
import { decryptAES } from '../../../utils/Encryption';
import QCServices from '../../../services/axioServices/apiServices/QCServices';
import { isValidForm } from '../../../utils/validation/CommonValidator';

export default class RawMaterialTestEntryDetails extends Component {
    constructor(props) {
        super(props);
        this.qcServices = new QCServices();
        this.itemMasterServices = new ItemMasterServices();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.state = {
            route: null,
            analystList: [],
            testReportRMId: null,
            sampleEntryRMId: null,
            labList: [],
            inchargeList: [],
            reportObject: {
                refNo: "",
                reportNo: "",
                reportDate: "",
                materialName: "",
                batchNo: "",
                partyName: "",
                purchaseQty: "",
                mfgBy: "",
                analyst: "",
                labId: "",
                labIncharge: "",
                materialId: "",
                analysisDate: ""
            },
            testObject: {
                testName: "",
                result: "",
                limit: "",
                isEditing: false,
                monogramId: "",
                index: null
            },
            tableData: [],
            columns: [
                { field: 'testName', header: 'Test Name' },
                { field: 'result', header: 'Result' },
                { field: 'limit', header: 'Limit' },
                { field: 'action', header: 'Action', body: this.actionTemplate, sortable: false }
            ],
            validationRules: {
                reportNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "report no"
                        ),
                    },
                ],
                reportDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "report date"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let sampleEntryRMId = decryptAES(id)
            if (sampleEntryRMId) {
                if (sampleEntryRMId != null) {
                    this.setState({ sampleEntryRMId: sampleEntryRMId }, () => {
                        this.getRawMaterialSampleEntryDetailsById(this.state.sampleEntryRMId)
                    });
                }
            }
        }
        let RMTestId = params.get("RMTestId")
        if (RMTestId) {
            let testReportRMId = decryptAES(RMTestId)
            if (testReportRMId) {
                if (testReportRMId != null) {
                    this.setState({ testReportRMId: testReportRMId }, () => {
                        this.getRawMaterialTestEntryDetailsById(this.state.testReportRMId)
                    });
                }
            }
        }
    }

    getRawMaterialSampleEntryDetailsById = (sampleEntryRMId) => {
        this.qcServices.getRawMaterialSampleEntryDetailsById(sampleEntryRMId).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let details = this.state.reportObject
                details.refNo = res.refNo
                details.batchNo = res.batchNo
                details.invoiceNo = res.invoiceNo
                details.mfgBy = res.mfgBy
                details.labName = res.labName
                details.grnId = res.grnId
                details.purchaseQty = res.purchaseQty
                details.partyName = res.partyName
                details.materialName = res.materialName
                details.materialId = res.rmId
                details.sampleQty = res.sampleQty
                this.setState({ reportObject: details }, () => {
                    this.getQCMonogramByRMId(this.state.reportObject.materialId)
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getRawMaterialTestEntryDetailsById = (testReportRMId) => {
        this.qcServices.getRawMaterialTestEntryDetailsById(testReportRMId).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let reportObject = this.state.reportObject
                reportObject.analyst = res.analyst
                reportObject.batchNo = res.batchNo
                reportObject.grnId = res.grnId
                reportObject.labIncharge = res.labIncharge
                reportObject.labName = res.labName
                reportObject.materialName = res.materialName
                reportObject.mfgBy = res.mfgBy
                reportObject.partyName = res.partyName
                reportObject.purchaseQty = res.purchaseQty
                reportObject.refNo = res.refNo
                reportObject.reportDate = res.reportDate
                reportObject.reportNo = res.reportNo
                reportObject.sampleQty = res.sampleQty
                reportObject.analysisDate = res.analysisDate
                this.setState({ reportObject: reportObject, tableData: res.tableData, sampleEntryRMId: res.sampleEntryRMId })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getQCMonogramByRMId = (id) => {
        this.itemMasterServices.getQCMonogramByRMId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                const tableData = res.map(({ _id, ...rest }) => ({
                    ...rest,
                    monogramId: _id
                }));
                this.setState({ tableData: tableData })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "report") {
            let details = this.state.reportObject;
            details[name] = value.toUpperCase();
            this.setState({ reportObject: details });
        } else {
            let details = this.state.testObject;
            details[name] = value.toUpperCase();
            this.setState({ testObject: details });
        }
    };

    setFilterParametersForItemName = (selected, name) => {
        if (selected.value) {
            let reportObject = this.state.reportObject;
            reportObject[name] = selected.value;
            this.setState({ reportObject: reportObject });
        }

    }

    actionTemplate = (rowData, options) => {
        return (
            <div className="flex gap-2">
                <button
                    className="search-btn w-[28px] h-[28px] bg-blue text-white rounded"
                    onClick={() => this.handleEdit(rowData, options)}
                >
                    <FontAwesomeIcon icon={faPen} className='w-[14px] h-[14px]' />
                </button>
            </div>
        );
    };

    handleEdit = (rowData, options) => {
        let details = this.state.testObject
        details.testName = rowData.testName
        details.result = rowData.result
        details.limit = rowData.limit
        details.isEditing = true
        details.index = options.rowIndex
        details.monogramId = rowData.monogramId
        this.setState({ testObject: details })
    }

    backPage = () => {
        this.setState({ route: '/RawMaterialTestReportEntry' });
    };

    clearTestObject = () => {
        let testObject = this.state.testObject
        testObject.testName = ''
        testObject.result = ''
        testObject.limit = ''
        testObject.isEditing = false
        testObject.monogramId = ''
        testObject.index = null
        this.setState({ testObject: testObject })
    }

    updateTestResult = () => {
        // let testObject = this.state.testObject
        // let tableData = this.state.tableData
        // const index = tableData.findIndex(item => item.monogramId === testObject.monogramId);

        // if (index !== -1) {
        //     tableData[index] = { ...tableData[index], ...testObject };
        //     this.setState({ tableData }, () => {
        //         this.clearTestObject()
        //     });
        // }

        let arr = [...this.state.tableData]
        let testObject = { ...this.state.testObject }
        arr[testObject.index] = testObject;
        this.setState({
            tableData: arr,
        }, () => {
            this.clearTestObject()
        });
    }


    isAllFieldsValidate = () => {
        const newValidState = isValidForm(
            this.state.reportObject,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid
    }

    addEditRawMaterialTestReport = () => {
        if (this.state.tableData.length === 0) {
            this.SwalServices.ErrorWithMonogram(
                ``,
                'Add Monogram',
                'Cancel',
                `Please add monogram for this raw material.`
            ).then((response) => {
                if (response) {
                    this.setState({ route: '/QCMonogramRawMaterial' })
                }
            });
        } else {
            let isValid = this.isAllFieldsValidate()
            if (isValid) {
                let reportObject = this.state.reportObject
                let request = {
                    reportNo: reportObject.reportNo,
                    reportDate: reportObject.reportDate,
                    analyst: reportObject.analyst,
                    labIncharge: reportObject.labIncharge,
                    analysisDate: reportObject.analysisDate,
                    sampleEntryRMId: this.state.sampleEntryRMId,
                    tableData: this.state.tableData
                }
                if (this.state.testReportRMId) {
                    request.testReportRMId = this.state.testReportRMId
                }
                this.qcServices.addEditRawMaterialTestReport(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData !== null) {
                        if (this.state.testReportRMId) {
                            this.backPage()
                        } else {
                            this.backPage()
                        }
                        this.SwalServices.Success(response.Message)
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                })
            }
        }
    }

    generateTestingEntryRmReport = () => {
        this.setState({ isLoading: 'print' }, () => {
            let request = [this.state.testReportRMId]
            this.qcServices.generateTestingEntryRmReport(request).then((response) => {
                if (response && response.status === 200) {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    // let blob = new Blob([response.data])
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.click();
                    this.setState({ isLoading: "" })
                }
                this.setState({ isLoading: false });
            })
        })
    }

    render() {
        if (this.state.route !== null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='raw-sample-fields'>
                <h1 className='text-[18px] font-semibold text-blue pb-[5px] mb-[5px]'>Raw Material Test Entry</h1>
                <RawMaterialTestEntryInputs
                    reportObject={this.state.reportObject}
                    testObject={this.state.testObject}
                    handleChange={this.handleChange}
                    setFilterParametersForItemName={this.setFilterParametersForItemName}
                    analystList={this.state.analystList}
                    inchargeList={this.state.inchargeList}
                    labList={this.state.labList}
                    tableData={this.state.tableData}
                    columns={this.state.columns}
                    clearTestObject={this.clearTestObject}
                    updateTestResult={this.updateTestResult}
                    validState={this.state.validState}
                    testEntryType='RawMaterial'
                />
                <div className='btn-grp flex items-center gap-5 mt-2.5'>
                    <button
                        className='search-btn'
                        onClick={this.addEditRawMaterialTestReport}
                    >
                        Save
                    </button>
                    <button className='cancel-btn'
                        onClick={this.backPage}
                    >
                        Cancel
                    </button>
                    {this.state.testReportRMId !== null && this.state.testReportRMId !== undefined && this.state.testReportRMId !== "" ?
                        <button className='print-btn' onClick={this.generateTestingEntryRmReport}>Print</button>
                        : null}
                </div>
            </div>
        )
    }
}
